<template>
  <div>
    <iframe style="display: none" id="downloadiframe" />
    <component :is="route.meta.layout">
      <router-view />
    </component>

    <v-snackbar
      v-model="notifierState.opened"
      :color="notifierState.color"
      :timeout="notifierState.timeout"
    >
      {{ notifierState.message }}
    </v-snackbar>
    <ConfirmPopup />
  </div>
</template>

<script lang="ts" setup>
import { useRoute } from "vue-router";
import { useNotifierStore } from "./store/notifier";
import { useConfirmStore } from "./store/confirm";
import ConfirmPopup from "./components/base/popups/ConfirmPopup.vue";

const $notifier = useNotifierStore();
const notifierState = $notifier.state;

const $confirm = useConfirmStore();

const route = useRoute();
</script>

<style>
@import "./assets/global.css";
</style>
